import { apiSlice } from "app/api/apiSlice"


export const aiSettingsApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['aiSettings'],
    endpoints: builder => ({
        getAiSettings: builder.query({
            query: () => 'ai/settings',
            keepUnusedDataFor: 5,
            providesTags: ['aiSettings']
        }),
        setAiSettings: builder.mutation({
            query: data => ({
                url: 'ai/settings',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['aiSettings']
        })
    })
})

export const {
    useGetAiSettingsQuery,
    useLazyGetAiSettingsQuery,
    useSetAiSettingsMutation
} = aiSettingsApiSlice